define('modules/list/list_model',['backbone'], function(Backbone) {
 'use strict';
 var List = Backbone.Model.extend({
  defaults: function() {
    return {

    };
  }
});

 return List;
});
